import Reflux from 'reflux';
import FilterAction from '../action/filterAction';

export default Reflux.createStore({
  listenables: FilterAction,
  onPublishNewData: function(data) {
    this.trigger(data);
  },
});



/** WEBPACK FOOTER **
 ** ./assets/src/frontend/preview/store/filterStore.js
 **/